import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

import { UsuarioService } from '../services/usuario.service';
import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ProfissionalService } from '../services/profissional.service';
import { VeiculoService } from '../services/veiculo.service';
import { EquipeService } from '../services/equipe.service';
import { EmbarqueEquipeService } from '../services/embarque-equipe.service';
import { TipoProfissionalService } from '../services/tipo-profissional.service';


@Component({
  selector: 'app-embarque-equipe-edit',
  templateUrl: './embarque-equipe-edit.component.html',
  styleUrls: ['./embarque-equipe-edit.component.css'],
	animations: [loadingFade]
})
export class EmbarqueEquipeEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public inicioPeriodo;

	public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];
  public equipes: any;
  public cliente: any;
  public profissionaisEdit = [];
  public tipoProfissional = null; 

  public embarque_equipe_id = null;
  public profissional = null;

  public equipe = [];
  public item_equipe_array = [];
  public pros = false;

  public exibeSubmit = true;

  // datepickers
	private data_checklist_dp;

  //filtro
  public cliente_id___cliente = null;
  public unidade_id___unidade = null;
  public veiculo_id___veiculo = null;
  public embarque_equipe_turno___periodo =  null;
  public embarque_equipe_status___status =  null;
  public embarque_equipe_data___data_i = null;
  public embarque_equipe_data___data_f = null;
  public profissional_id___profissional =  null;


  constructor(private authSvc: AuthService,
    private usuarioSvc: UsuarioService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private clienteSvc: ClienteService,
    private unidadeSvc: UnidadeService,
    private profissionalSvc: ProfissionalService ,
    private veiculoSvc: VeiculoService,
    private equipeSvc: EquipeService,
    private embarqueEquipeSvc: EmbarqueEquipeService,
    private tipoProfissionalSvc: TipoProfissionalService,
    ) { }

  ngOnInit() {

    this.loading = true;    
    this.pegaAgencias();
    this.criaForm();
    this.verificaCliente();
    //this.pegaVeiculosBase();    

		this.route.params.subscribe( params => {	
      
      
      if (params.id) {

        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "embarque_equipe_turno___periodo": { 
                this.embarque_equipe_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "embarque_equipe_data___data_i": { 
                this.embarque_equipe_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "embarque_equipe_data___data_f": { 
                this.embarque_equipe_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }


        }        

				  this.embarque_equipe_id = params.id;
				  this.embarqueEquipeSvc.getEmbarqueEquipe(params.id).then((data: any) => {

          this.cliente = data.cliente.dns_aplicacao.split('.')[0];
          this.pegaUnidadesByAgencia(data.cliente_id);
          //this.pegaVeiculos(this.cliente);
          //this.pegaEquipes(this.cliente, data.equipe_id);

          
					this.preencheForm({
            embarque_equipe_id:  data.embarque_equipe_id,
            usuario_id:  data.usuario_id,
            embarque_equipe_data:  moment(data.embarque_equipe_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            embarque_equipe_turno:  data.embarque_equipe_turno,
            embarque_equipe_status: data.embarque_equipe_status,
            embarque_equipe_justificativa: data.embarque_equipe_justificativa,
            cliente_id:  data.cliente_id,
            unidade_id:  data.unidade_id,
            profissional_id:  data.profissional_id,
            veiculo_id:  data.veiculo_id,
            equipe_id: data.equipe_id,
            profissionais: []
          });
          
          this.pegaProfissionaisClienteUnidade(data);
          this.onChangeVeiculoUnidade(data);
        
          this.pros = true;
          const equipe = this.formChecklist.get('profissionais') as FormArray;
          
          //for(let pro of data.profissionais)
          //{
          //    //console.log("[tipo =]" , pro.profissional.tipo_profissional.tipo_profissional_nome);
          //    equipe.push(this.createItemEquipe(pro.embarque_equipe_profissional_nome, pro.samu_profissional_id, pro.embarque_equipe_profissional_presenca, pro.profissional.tipo_profissional.tipo_profissional_nome));
          //}

          this.profissionais = []
          this.embarqueEquipeSvc.getBuscaProfissionaisEquipeCad(data.embarque_equipe_id).then((data: any[]) => {
          this.profissionais = data;
      
            for(let profissional of this.profissionais){
              equipe.push(this.createItemEquipe(profissional.profissional_nome, profissional.profissional_id, profissional.embarque_equipe_profissional_presenca, profissional.tipo_profissional_nome));
            }
      
          }).catch((err) => {
            console.log(err); 
          });          


          this.verificaCliente();      
          this.pegaEquipesClienteUnidade(data.cliente_id, data.unidade_id, data.equipe_id)
          
          this.formChecklist.controls['equipe_id'].disable();
          if(params.visualizar == "ver"){
            this.loading = true;
            this.formChecklist.controls['embarque_equipe_data'].disable();
            this.formChecklist.controls['embarque_equipe_turno'].disable();
            this.formChecklist.controls['embarque_equipe_justificativa'].disable();
            this.formChecklist.controls['cliente_id'].disable();
            this.formChecklist.controls['unidade_id'].disable();
            this.formChecklist.controls['profissional_id'].disable();
            this.formChecklist.controls['veiculo_id'].disable();
            this.formChecklist.controls['profissionais'].disable();            
            this.exibeSubmit = false;
            this.loading = false;
          }

          this.loading = false;
				});



        
			} 


			else {
				this.loading = false;
			}
      
    });
  }

  criaForm(){
    
    this.formChecklist = this.fb.group({
      embarque_equipe_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
      embarque_equipe_data: [moment().format('DD/MM/YYYY'), Validators.required],
      embarque_equipe_turno: [this.pegaPeriodo(), Validators.required],
      embarque_equipe_status: null,
      embarque_equipe_justificativa: null,
      cliente_id: [null, Validators.required],
      unidade_id: [null, Validators.required],
      profissional_id: [this.profissional, Validators.required],
      veiculo_id: [null, Validators.required],
      equipe_id: [null, Validators.required],
      profissionais: this.fb.array([])
    });
    
    moment.locale('pt-Br');
    this.data_checklist_dp = Datepicker('#embarque_equipe_data', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formChecklist.controls['embarque_equipe_data'].setValue(formatted);
			}
    });

    if(this.authSvc.getPerfil() != 2){
      this.usuarioSvc.getUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
        this.profissional = data.profissional_id;
        this.formChecklist.get('profissional_id').setValue(data.profissional_id);
        this.formChecklist.get('profissional_id').updateValueAndValidity();
        this.formChecklist.get('profissional_id').disable();
      });
    }

  }

  preencheForm(dados) {
		this.formChecklist.setValue(dados);
  }


  pegaPeriodo(){
    let hora = parseInt(moment().format('HH'));
    if(hora > 7  &&  hora < 19){
      return 'D';
    }
    else{
      return 'N';
    }
  }

  pegaAgencias(){
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.agencias = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaUnidadesByAgencia(agencia_id){

    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });

  }
  
  pegaEquipes(cliente, equipe){
    this.equipeSvc.getEquipes(cliente, equipe).then((data: any[]) => {
      this.equipes = data;
		}).catch((err) => {
			console.log(err);
    });
  }


  pegaEquipesPorVeiculo(veiculo_id){

    this.equipeSvc.getEquipesPorVeiculo(veiculo_id).then((data: any[]) => {
    this.equipes = data;

      //Carrega Profissionais da Equipe
      for(let equipe of this.equipes){
        this.getProfissionaisEquipeVeiculo(equipe.equipe_id);
      } 

		}).catch((err) => {
			console.log(err);
    });
  }

  pegaEquipesClienteUnidade(cliente, unidade, equipe){
    this.equipeSvc.getEquipesClienteUnidade(cliente, unidade, equipe).then((data: any[]) => {
      this.equipes = data;
		}).catch((err) => {
			console.log(err);
    });
  }

  /*pegaVeiculos(cliente){
    this.equipeSvc.getVeiculos(cliente).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
    });
  }*/

  onChangeAgencia(e){
    this.formChecklist.controls.unidade_id.setValue(null);
    this.formChecklist.controls.veiculo_id.setValue(null);
    this.formChecklist.controls.profissional_id.setValue(null);
    this.verificaCliente();
    this.cliente = e.dns_aplicacao.split('.')[0];
    //this.pegaVeiculos(this.cliente);

    //this.pegaVeiculos();
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeVeiculo(e){
    this.formChecklist.controls.equipe_id.setValue(null);
    this.pros = false;
    //this.pegaEquipes(this.cliente, e.equipe_id );
    this.pegaEquipesPorVeiculo(e.veiculo_id);
  }

  pegaProfissionais(){
    this.profissionalSvc.getProfissionais().then((data: any[]) => {
			this.profissionais = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  pegaProfissionaisClienteUnidade(e){
    this.loading = true;
    this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
			this.profissionais = data;

      this.loading = false;
		}).catch((err) => {
			console.log(err);
		});
  }

  invalid(nome) {
    let input = this.formChecklist.get(nome);
		return input.touched && input.invalid;
  }
  
  verificaCliente() {
		if (this.formChecklist.get('cliente_id').value)
			this.formChecklist.get('unidade_id').enable();
		else
			this.formChecklist.get('unidade_id').disable();
  }
  
  
  enviaChecklist() {
    if (this.formChecklist.valid) {
      this.submitting = true;
      this.formChecklist.get('profissional_id').enable();
      this.formChecklist.controls['equipe_id'].enable();
      let toSend = this.formChecklist.value;

      if (this.embarque_equipe_id === null) { // criar
        toSend.embarque_equipe_registro = moment().format('YYYY-MM-DD HH:mm:ss');
        toSend.embarque_equipe_status = 'A';

				this.embarqueEquipeSvc.criaEmbarqueEquipe(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Embarque cadastrado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/embarqueequipe']);
            }
          });
				}).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
			else { // editar
				this.embarqueEquipeSvc.editaEmbarqueEquipe(toSend).then((data) => {
          console.log('resp', data);
				  Swal.fire({
            type: 'success',
            title: 'Embarque alterado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/embarqueequipe']);
            }
          });
				}).catch(err => {
					console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
    }
    else{
      Swal.fire({
        type: 'error',
        title: 'Embarque incompleto!',
        text: 'Verifique os itens em vermelho!'
      });
      for( let field in this.formChecklist.controls){
        let campo = this.formChecklist.get(field);
        campo.markAsTouched();
      }
    }
  }

  
	createItemEquipe(nome = null, id = null, presenca = null, tipo_profissional_nome = null){
		return this.fb.group({
      samu_profissional_id: [id],
      embarque_equipe_profissional_nome: [nome],
			embarque_equipe_profissional_presenca: [presenca, [Validators.required]],
      tipo_profissional_nome: tipo_profissional_nome
		})
	}


  onChangeEquipe(e){

    if(e != null){
      const equipes = this.formChecklist.get('profissionais') as FormArray;
      console.log(e);
      
      for(let i = equipes.controls.length; i >= 0; i--){
        equipes.removeAt(i);
      }

      if(e.profissionais.length > 0){
        this.pros = true;
        for(let profissional of e.profissionais){
          equipes.push(this.createItemEquipe(profissional.profissional_nome, profissional.profissional_id));
        }
      }
      else{
        this.pros = false;
      }
    }
    else{
      this.pros = false;
    }
  }




  onChangeEquipeNovo(e){

      //Remove Profissionais em tela 
      const equipes = this.formChecklist.get('profissionais') as FormArray;
      for(let i = equipes.controls.length; i >= 0; i--){
        equipes.removeAt(i);
      }   

      this.pros = true;   
      if(this.embarque_equipe_id){

          this.profissionais = []
          this.embarqueEquipeSvc.getBuscaProfissionais(this.embarque_equipe_id).then((data: any[]) => {
          this.profissionais = data;
      
            for(let profissional of this.profissionais){
              equipes.push(this.createItemEquipe(profissional.profissional_nome, profissional.profissional_id, profissional.embarque_equipe_profissional_presenca));
            }
      
          }).catch((err) => {
            console.log(err); 
          });

      }else{

        this.profissionais = []
        this.embarqueEquipeSvc.getBuscaProfissionaisEquipeCad(e.equipe_id).then((data: any[]) => {
        this.profissionais = data;
    
          for(let profissional of this.profissionais){
            equipes.push(this.createItemEquipe(profissional.profissional_nome, profissional.profissional_id, null));
          }
    
        }).catch((err) => {
          console.log(err); 
        });     
    }

  }

  getProfissionaisEquipeVeiculo(equipe_id){

    this.formChecklist.controls.equipe_id.setValue(equipe_id);
    this.formChecklist.controls['equipe_id'].disable(); 

    this.pros = true;  
    const equipes = this.formChecklist.get('profissionais') as FormArray;
    for(let i = equipes.controls.length; i >= 0; i--){
      equipes.removeAt(i);
    }   
    this.profissionais = []
    this.embarqueEquipeSvc.getBuscaProfissionaisPorEquipe(equipe_id).then((data: any[]) => {
    this.profissionais = data;

      for(let profissional of this.profissionais){
        equipes.push(this.createItemEquipe(profissional.profissional_nome, profissional.profissional_id, null, profissional.tipo_profissional_nome));
      }

    }).catch((err) => {
      console.log(err); 
    });

  }

  

  getBuscaProfissionais(){
    this.embarqueEquipeSvc.getBuscaProfissionais(this.embarque_equipe_id).then((data: any[]) => {
			this.profissionaisEdit = data;
      return this.profissionaisEdit;
		}).catch((err) => {
			console.log(err);
		});

  }


	pegaVeiculosBase() {
		this.veiculos = [];
		this.loading = true;
		this.veiculoSvc.getVeiculosByUsuario(this.authSvc.getUsuarioId()).then((data: any) =>{
			this.veiculos = data;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

  pegaVeiculos() {
		this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			let dados = [];
			for(let veiculo of data){
				dados.push({
					veiculo_id: veiculo.veiculo_id,
					veiculo_label: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
					unidade_id: veiculo.unidade_id,
					cliente_id: veiculo.cliente_id,
				});
			}
			this.veiculos = dados;
		}).catch((err) => {
			console.log(err)
		});
	}

  onChangeVeiculoUnidade(e){

    this.loading = true;
		this.veiculos = []
		this.veiculoSvc.getByVeiculoClienteUnidade(e.unidade_id,e.cliente_id).then((data: any[]) => {

        let dados = [];
        for(let veiculo of data){
          dados.push({
            veiculo_id: veiculo.veiculo_id,
            placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
            unidade_id: e.unidade_id,
            cliente_id: e.cliente_id
          });
        }

        this.veiculos = dados;

        this.pegaProfissionaisClienteUnidade(e);

        this.loading = false;
      }).catch((err) => {
        console.log(err);
      });
	  }

    onClickVoltar(){

      let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
      params += "&unidade_id___unidade=" + this.unidade_id___unidade;
      params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
      params += "&embarque_equipe_turno___periodo=" + this.embarque_equipe_turno___periodo;
      params += "&embarque_equipe_data___data_i=" + this.embarque_equipe_data___data_i;
      params += "&embarque_equipe_data___data_f=" + this.embarque_equipe_data___data_f;
      params += "&profissional_id___profissional=" + this.profissional_id___profissional;
  
      //this.router.navigate(['/home/embarqueequipefiltro/' + params]);

      this.router.navigate(['/home/embarqueequipe']);
  
    }


}